
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/italian-stories",
      function () {
        return require("private-next-pages/italian-stories/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/italian-stories"])
      });
    }
  